"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _useComputedColor3 = require("../../hooks/useComputedColor");
var _Button = _interopRequireDefault(require("../Button"));
var _XIcon = _interopRequireDefault(require("../../assets/Icons/XIcon"));
var _useColorUtils2 = require("../../hooks/useColorUtils");
var _InfoIconThin = _interopRequireDefault(require("../../assets/Icons/InfoIconThin"));
var _CircleCheckIconThin = _interopRequireDefault(require("../../assets/Icons/CircleCheckIconThin"));
var _WarningIcon = _interopRequireDefault(require("../../assets/Icons/WarningIcon"));
var _ErrorIconThin = _interopRequireDefault(require("../../assets/Icons/ErrorIconThin"));
var _CommonSerializedStyles = require("../../internals/styles/CommonSerializedStyles");
var _excluded = ["severity", "severityMapping", "icon", "iconMapping", "iconFillColor", "action", "closeText", "onClose", "color", "header", "message", "children", "sx", "componentsProps"];
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SnackbarHeader = _styled.default.header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 32px;\n    display: grid;\n    width: 100%;\n    grid-template-columns: auto minmax(auto, 1fr) 32px;\n    grid-auto-flow: column;\n    column-gap: var(--header-padding, 16px);\n    margin-bottom: var(--body-margin-top, 0px);\n    justify-content: space-between;\n    align-items: center;\n"])));
var DEFAULT_SEVERITY_MAPPING = {
  info: ['transparent', 'secondary'],
  error: 'error',
  success: 'success',
  warning: 'warning'
};
var DEFAULT_ICON_MAPPING = {
  info: _InfoIconThin.default,
  error: _ErrorIconThin.default,
  success: _CircleCheckIconThin.default,
  warning: _WarningIcon.default
};
var PADDING_BASE = 15;
var BORDER_BASE = 8;
var SnackbarPaper = (0, _styled.default)(_Paper.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n"])), _CommonSerializedStyles.MuiBoxSizingWildcard);
var Snackbar = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$severity = _ref.severity,
    severity = _ref$severity === void 0 ? 'info' : _ref$severity,
    _ref$severityMapping = _ref.severityMapping,
    severityMappingProp = _ref$severityMapping === void 0 ? {} : _ref$severityMapping,
    icon = _ref.icon,
    _ref$iconMapping = _ref.iconMapping,
    iconMappingProp = _ref$iconMapping === void 0 ? {} : _ref$iconMapping,
    iconFillColor = _ref.iconFillColor,
    action = _ref.action,
    _ref$closeText = _ref.closeText,
    closeText = _ref$closeText === void 0 ? 'Close' : _ref$closeText,
    onClose = _ref.onClose,
    color = _ref.color,
    header = _ref.header,
    messageProp = _ref.message,
    children = _ref.children,
    sx = _ref.sx,
    componentsProps = _ref.componentsProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useColorUtils = (0, _useColorUtils2.useColorUtils)(),
    getThemeColor = _useColorUtils.getThemeColor;
  var message = children || messageProp;
  var severityMapping = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_SEVERITY_MAPPING), severityMappingProp);
  }, [severityMappingProp]);
  var iconMapping = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_ICON_MAPPING), iconMappingProp);
  }, [iconMappingProp]);
  var _useMemo = (0, _react.useMemo)(function () {
      var severityValue = severityMapping === null || severityMapping === void 0 ? void 0 : severityMapping[severity];
      if (Array.isArray(severityValue)) {
        return severityValue;
      }
      return [severityValue, severityValue];
    }, [severityMapping, severity]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    borderSeverity = _useMemo2[0],
    iconSeverity = _useMemo2[1];
  var _useComputedColor = (0, _useComputedColor3.useComputedColor)({
      color: color,
      defaultColor: borderSeverity
    }),
    borderColor = _useComputedColor.computedColor;
  var _useComputedColor2 = (0, _useComputedColor3.useComputedColor)({
      color: iconFillColor || color,
      defaultColor: iconSeverity
    }),
    iconColor = _useComputedColor2.computedColor;
  var iconElement = (0, _react.useMemo)(function () {
    if (icon === false) {
      return null;
    }
    if (icon) {
      return icon;
    }
    var SeverityIconComponent = iconMapping[severity];
    return /*#__PURE__*/_react.default.createElement(SeverityIconComponent, _extends({
      width: "20",
      height: "20",
      fill: iconColor
    }, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.headerIcon));
  }, [icon, iconMapping, severity, iconColor, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.headerIcon]);
  var actionElement = (0, _react.useMemo)(function () {
    if (action) {
      return action;
    }
    if (onClose) {
      return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
        intent: "tertiary",
        title: closeText,
        size: "small",
        icon: function icon() {
          return /*#__PURE__*/_react.default.createElement(_XIcon.default, {
            width: "16",
            height: "16",
            fill: getThemeColor('secondary')
          });
        },
        onClick: onClose
      }, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.closeButton));
    }
    return null;
  }, [action, closeText, getThemeColor, onClose, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.closeButton]);
  var isBorderTransparent = borderColor === 'transparent';
  var paddingLeft = (0, _react.useMemo)(function () {
    return "".concat(PADDING_BASE + (isBorderTransparent ? BORDER_BASE : 0), "px");
  }, [isBorderTransparent]);
  var borderLeft = (0, _react.useMemo)(function () {
    return !isBorderTransparent && "".concat(BORDER_BASE, "px solid ").concat(borderColor);
  }, [borderColor, isBorderTransparent]);
  var paperSx = (0, _react.useMemo)(function () {
    return _objectSpread({
      display: 'flex',
      flexDirection: 'column',
      padding: "".concat(PADDING_BASE, "px"),
      paddingLeft: paddingLeft,
      borderLeft: borderLeft,
      borderRadius: '4px',
      '--body-margin-top': header && message && '8px',
      '--header-padding': header && '8px'
    }, sx);
  }, [borderLeft, header, message, paddingLeft, sx]);
  return /*#__PURE__*/_react.default.createElement(SnackbarPaper, _extends({
    color: borderColor,
    variant: "regular"
  }, props, {
    sx: paperSx,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(SnackbarHeader, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.header, iconElement, header || message, actionElement), header && message);
});
var _default = Snackbar;
exports.default = _default;